import { BRAND, isMarketGB } from 'src/constants/main';
import { CarNumberStyled } from './CarNumberStyled';
import { SC } from 'src/styles/theme';
import React from 'react';
import { CarNumberStyledAC } from './AC/CarNumberStyledAC';
import { CarNumberStyledAP } from './AP/CarNumberStyledAP';
import { CarNumberStyledDS } from './DS/CarNumberStyledDS';
import { CarNumberStyledOV } from './OV/CarNumberStyledOV';
import { CarNumberStyledOVGB } from './OV/CarNumberStyledOVGB';

export interface CarNumberProps extends SC {
    numCar?: string;
}

export const CarNumber = (props: CarNumberProps) => {
    if (BRAND === 'AC') return <CarNumberStyledAC {...props} />;
    if (BRAND === 'AP') return <CarNumberStyledAP {...props} />;
    if (BRAND === 'DS') return <CarNumberStyledDS {...props} />;
    if (BRAND === 'OV') return isMarketGB ? <CarNumberStyledOVGB {...props} /> : <CarNumberStyledOV {...props} />;
    return <CarNumberStyled {...props} />;
};

export default CarNumber;
